import React from "react";
import PropTypes from "prop-types";
import {
  HashRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
// import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import TableViewIcon from "@mui/icons-material/TableView";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BarChartIcon from "@mui/icons-material/BarChart";
import DescriptionIcon from "@mui/icons-material/Description";
import LayersIcon from "@mui/icons-material/Layers";
import { AppProvider } from "@toolpad/core/AppProvider";
import { DashboardLayout } from "@toolpad/core/DashboardLayout";
import logoMapache from "../img/logo_mapache.png";
import admifin from "../img/admfin.png";
import conta from "../img/conta.png";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import PonderadosPues from "./PonderadosPues";
import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import SchoolIcon from "@mui/icons-material/School";
import InfoIcon from "@mui/icons-material/Info";
import FAQPage from "./FAQPage";
import CentroEstudiantes from "./CentroEstudiantes";
import { Stack, Typography } from "@mui/material";
import AcercaDe from "./AcercaDe";
import Contactos from "./Contactos";
import CarreraContaduria from "./CarreraContaduria";
const NAVIGATION = [
  {
    segment: "#/",
    title: "Ponderados Pues",
    icon: <TableViewIcon />,
  },
  {
    segment: "#/Informate",
    title: "Infórmate",
    icon: <AssignmentIcon />,
  },
  {
    segment: "#/Contaduria-Publica",
    title: "Contaduría Pública",
    icon: <HistoryEduIcon />,
  },
  {
    segment: "#/CE-Conta-Pues",
    title: "C.E. Conta P.U.E.S",
    icon: <SchoolIcon />,
  },
  { kind: "divider" },
  {
    segment: "#/acerca-de",
    title: "Acerca de la aplicación",
    icon: <InfoIcon />,
  },
  {
    segment: "#/Contactos",
    title: "Contactanos",
    icon: <PermPhoneMsgIcon />,
  },
  // { kind: "header", title: "Analytics" },
  // {
  //   segment: "/reports",
  //   title: "Reports",
  //   icon: <BarChartIcon />,
  //   children: [
  //     {
  //       segment: "/reports/sales",
  //       title: "Sales",
  //       icon: <DescriptionIcon />,
  //     },
  //     {
  //       segment: "/reports/traffic",
  //       title: "Traffic",
  //       icon: <DescriptionIcon />,
  //     },
  //   ],
  // },
  // {
  //   segment: "/integrations",
  //   title: "Integrations",
  //   icon: <LayersIcon />,
  // },
];

function CustomAppTitle() {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <div className="logo-container bg-red">
        <img
          src={logoMapache}
          alt="Logo Mapache"
          className="App-logo"
        />
      </div>
      <h1 className="app-title text-title1 text-whit">App Pues</h1>
      {/* <Tooltip title="Connected to production" /> */}
    </Stack>
  );
}

function ToolbarActionsSearch() {
  return (
    <Stack direction={{ xs: "column", sm: "row" }}>
      <Box
        sx={{
          display: "flex", // Flexbox para mantener todo en una fila
          flexWrap: "nowrap", // Evitar saltos de fila
          overflowX: "auto", // Scroll horizontal si no hay espacio
          alignItems: "center", // Centrar las imágenes verticalmente
          gap: 1, // Espaciado entre elementos
        }}
      >
        <img
          src={conta}
          alt="Logo Mapache"
          style={{
            height: "40px", // Ajustar el tamaño según necesites
            flexShrink: 0, // Evitar que se reduzca en exceso
          }}
        />
        <img
          src={admifin}
          alt="Logo Mapache"
          style={{
            height: "40px",
            flexShrink: 0,
          }}
        />
      </Box>
      {/* <ThemeSwitcher /> */}
    </Stack>
  );
}

function SidebarFooter({ mini }) {
  return (
    <Typography
      variant="caption"
      className="text-red"
      sx={{ m: 1, whiteSpace: "nowrap", overflow: "hidden" }}
    >
      {mini
        ? "© App Pues Beta v1.2"
        : `© ${new Date().getFullYear()} App Pues Beta v1.2`}
    </Typography>
  );
}

const demoTheme = createTheme({
  cssVariables: { colorSchemeSelector: "data-toolpad-color-scheme" },
  colorSchemes: { light: true, dark: false },
  breakpoints: {
    values: { xs: 0, sm: 600, md: 600, lg: 1200, xl: 1536 },
  },
});

function DemoPageContent({ title }) {
  return (
    <Box
      sx={{
        py: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Typography variant="h4">Bienvenido a {title}</Typography>
    </Box>
  );
}

DemoPageContent.propTypes = {
  title: PropTypes.string.isRequired,
};

function MainPage(props) {
  const { window } = props;
  const demoWindow = window !== undefined ? window() : undefined;

  return (
    <AppProvider
      navigation={NAVIGATION}
      theme={demoTheme}
      window={demoWindow}
    >
      <Router>
        <DashboardLayout
          slots={{
            appTitle: CustomAppTitle,
            toolbarActions: ToolbarActionsSearch,
            sidebarFooter: SidebarFooter,
          }}
        >
          <Routes>
            <Route path="/" element={<PonderadosPues />} />

            <Route path="/Informate" element={<FAQPage />} />
            <Route path="/Informate/:slug" element={<FAQPage />} />
            <Route
              path="/CE-Conta-Pues"
              element={<CentroEstudiantes />}
            />
            <Route
              path="/Contaduria-Publica"
              element={<CarreraContaduria />}
            />
            <Route path="/acerca-de" element={<AcercaDe />} />
            <Route path="/Contactos" element={<Contactos />} />
            <Route
              path="/reports/traffic"
              element={<DemoPageContent title="Traffic" />}
            />
            <Route
              path="*"
              element={
                <Box sx={{ textAlign: "center", py: 4 }}>
                  <Typography variant="h4">
                    404 - Página no encontrada
                  </Typography>
                </Box>
              }
            />
          </Routes>
        </DashboardLayout>
      </Router>
    </AppProvider>
  );
}

// MainPage.propTypes = {
//   window: PropTypes.func,
// };

export default MainPage;
